import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Row,
  Col,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  CardHeader,
} from "reactstrap";
import UpdateContactDetails from "./UpdateContactDetails";
import { getPerson as onGetPerson } from "slices/thunks";

const ContactDetails = ({ person }: { person: any }) => {
  const [openFlush, setOpenFlush] = useState("1");
  const toggleFlush = (id: any) => {
    if (openFlush !== id) {
      setOpenFlush(id);
    }
  };

  const dispatch: any = useDispatch();

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const showUpdateModal = () => {
    setIsUpdateModalOpen(true);
  };

  return (
    <Card>
      <CardHeader className="d-flex align-items-center">
        <div className="text-muted flex-grow-1 d-flex align-items-center">
          <h6 className="mb-0 fw-semibold text-uppercase">Contact Details</h6>
        </div>
        <div className="flex-shrink-0 d-flex align-items-center">
          <Link
            to="#"
            onClick={(e) => {
              e.stopPropagation(); // Prevent collapse toggle on edit click
              showUpdateModal();
            }}
            className="link-primary link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover me-3"
          >
            <i className="ri-pencil-line"></i> Edit
          </Link>
        </div>
      </CardHeader>

      <CardBody className="card-body px-0 pt-0">
        <Row className="g-3">
          <Accordion
            id="default-accordion-example"
            flush
            open={openFlush}
            toggle={toggleFlush}
          >
            <AccordionItem className="material-shadow">
              <AccordionHeader targetId="1">Personal Contacts</AccordionHeader>
              <AccordionBody accordionId="1">
                <Row>
                  <Col sm={6} className="">
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-phone-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">Phone: </span>
                          <span>
                            {(person?.phoneNumber &&
                              person?.phoneNumber
                                .map((el: any) => el.name || "")
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-mail-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">Email: </span>
                          <span>
                            {(person?.emailAddress &&
                              person.emailAddress
                                .map((email: any) => email.name || "")
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-map-pin-2-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">
                            Physical Address:{" "}
                          </span>
                          <span>
                            {(person?.physicalAddress &&
                              person.physicalAddress
                                .map(
                                  (physical: any) =>
                                    `${physical.address || ""} ${
                                      physical.city || ""
                                    } ${physical.country || ""}`
                                )
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6} className="">
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-map-pin-user-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body">
                            Postal Address:{" "}
                          </span>
                          <span>
                            {(person?.postalAddress &&
                              person.postalAddress
                                .map(
                                  (postal: any) =>
                                    `${postal.address || ""} ${
                                      postal.city || ""
                                    } ${postal.country || ""}`
                                )
                                .join(", ")) ||
                              "Not Provided"}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="d-flex mb-2 align-items-baseline">
                      <div className="flex-shrink-0">
                        <div className="avatar-xxs">
                          <div className="avatar-title bg-light text-danger rounded fs-17">
                            <i className="ri-global-line text-primary"></i>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className=" mb-1" id="billing-address-line-1">
                          <span className="fw-semibold text-body me-1">
                            Website or Link:
                          </span>
                          <span>{person?.websiteOrLink || "Not Provided"}</span>
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </Row>
      </CardBody>
      <UpdateContactDetails
        isModalOpen={isUpdateModalOpen}
        toggle={() => setIsUpdateModalOpen((state) => !state)}
        person={person}
        fetchData={() => {
          dispatch(
            onGetPerson({
              id: person?.id,
            })
          );
        }}
      />
    </Card>
  );
};

export default ContactDetails;
